import React, { useEffect, useState } from "react";
import QAOrganizationContent from "../function-components/QAOrganizationContent";
import axios from "axios";

function QAOrganization() {
 

  return (
    <>
      <QAOrganizationContent />
    </>
  );
}

export default QAOrganization;
